import React, { useEffect } from 'react'
import { MVPButton } from '../../Views/Buttons/MVPButton'
import { useNavigate } from '../navigation'
import { useActiveGameId } from '../../state/hooks/ActiveGameHooks'
import '../../index.scss'
import './MainPage.scss'
import { LobbyChatView } from '../Lobby/Chat/LobbyChatView'

const GameCard = ({ onClick }: { onClick: () => void }) => {
	return (
		<div className='game-card' onClick={onClick}>
			<div className='game-card-overview' />
			<h2 className='game-card-label'>Live Dealt Poker</h2>
		</div>
	)
}

export default () =>
{
	const goToGame = useNavigate('game')
	const goToLobby = useNavigate('lobby')
	const activeGameId = useActiveGameId()

	useEffect(() => {
		if (activeGameId){
			const goToActiveRoom = async () => {
				goToGame({ replace: true })
			}
			goToActiveRoom()
		}
	}, [activeGameId])

	return (
		<div id='main-page-content'>
			<div id='center-col'>
				<h1 className='page-prompt'>Choose your preferred game</h1>
				<GameCard onClick={() => goToLobby()} />
				<MVPButton id='aditional-games-button'>Additional Games coming soon</MVPButton>
			</div>
			<LobbyChatView />
		</div>
	)
}
